const Reducer = (state = {
  memberList: [],
  paging: {
    page: 1,
    pageCount: 12,
  },
  teacherFormList: [],
  studentFormList: [],
}, { type, payload }) => {
  switch (type) {
    case "GET_MEMBER_LIST_SUCCESS":
      return { ...state, memberList: payload.results, paging: payload.paging };
    case "GET_TEACHER_FORM_LIST_SUCCESS":
      return { ...state, teacherFormList: payload};
    case "GET_STUDENT_FORM_LIST_SUCCESS":
      return { ...state, studentFormList: payload};
    default:
      return state;
  }
};

export default Reducer;
